module.exports = __webpack_public_path__ + "static/media/yuvo.7c5d010a.png";